import { apiCall } from './gqlClient';

const CHECKSUBSCRIPTIONOVERLAP_QUERY = `
  query checkSubscriptionOverlap($classId: Int!, $sessionIds: [Int]!, $customerId: Int, $email: String) {
    checkSubscriptionOverlap(classId: $classId, sessionIds: $sessionIds, customerId: $customerId, email: $email)
    {
      hasOverlap
      ...fragments
    }
  }`;

export const checkSubscriptionOverlapApiCall = async ({classId, sessionIds, customerId, email}, fragments = null) => apiCall({ query: CHECKSUBSCRIPTIONOVERLAP_QUERY, variables: {classId, sessionIds, customerId, email}, fragments });

const CHECKSESSIONSFORSUBSCRIPTIONN_QUERY = `
  query checkSessionsForSubscriptionN($request: CheckSessionsSubsNInput!) {
    checkSessionsForSubscriptionN(request: $request)
    {
      userId
			startActive
			endActive
			startReserved
			endReserved
      ...fragments
    }
  }`;

export const checkSessionsForSubscriptionNApiCall = async ({request}, fragments = null) => apiCall({ query: CHECKSESSIONSFORSUBSCRIPTIONN_QUERY, variables: {request}, fragments });

const GETSUBSCRIPTIONSOFUSERINSPECIFICCLASS_QUERY = `
  query getSubscriptionsOfUserInSpecificClass($classId: Int!, $userId: Int, $customerId: Int) {
    getSubscriptionsOfUserInSpecificClass(classId: $classId, userId: $userId, customerId: $customerId)
    {
      id
			userId
			serviceId
			providerId
			classId
			created
			updated
			total
			status
			email
			code
			appName
			onlineDiscount
			cancelled
			cancelledBy
			isItCancelledOnTime
			resourceEmail
			cancelledCounted
			presence
			startTime
      ...fragments
    }
  }`;

export const getSubscriptionsOfUserInSpecificClassApiCall = async ({classId, userId, customerId}, fragments = null) => apiCall({ query: GETSUBSCRIPTIONSOFUSERINSPECIFICCLASS_QUERY, variables: {classId, userId, customerId}, fragments });

const GETSUBSCRIPTIONPRICE_QUERY = `
  query getSubscriptionPrice($request: SubscriptionPriceRequest!) {
    getSubscriptionPrice(request: $request)
    {
      price
			discount
			priceWithoutDiscount
			userHasMembership
			waitingList
      ...fragments
    }
  }`;

export const getSubscriptionPriceApiCall = async ({request}, fragments = null) => apiCall({ query: GETSUBSCRIPTIONPRICE_QUERY, variables: {request}, fragments });

const GETSUBSCRIPTIONSBYSESSION_QUERY = `
  query getSubscriptionsBySession($sessionId: Int!) {
    getSubscriptionsBySession(sessionId: $sessionId)
    {
      id
			userId
			serviceId
			providerId
			classId
			created
			updated
			total
			status
			email
			code
			appName
			onlineDiscount
			cancelled
			cancelledBy
			isItCancelledOnTime
			resourceEmail
			cancelledCounted
			presence
			startTime
      ...fragments
    }
  }`;

export const getSubscriptionsBySessionApiCall = async ({sessionId}, fragments = null) => apiCall({ query: GETSUBSCRIPTIONSBYSESSION_QUERY, variables: {sessionId}, fragments });

const GETCANCELEDSUBSCRIPTIONSBYSESSION_QUERY = `
  query getCanceledSubscriptionsBySession($sessionId: Int!) {
    getCanceledSubscriptionsBySession(sessionId: $sessionId)
    {
      id
			userId
			serviceId
			providerId
			classId
			created
			updated
			total
			status
			email
			code
			appName
			onlineDiscount
			cancelled
			cancelledBy
			isItCancelledOnTime
			resourceEmail
			cancelledCounted
			presence
			startTime
      ...fragments
    }
  }`;

export const getCanceledSubscriptionsBySessionApiCall = async ({sessionId}, fragments = null) => apiCall({ query: GETCANCELEDSUBSCRIPTIONSBYSESSION_QUERY, variables: {sessionId}, fragments });

const GETSUBSCRIPTIONSSESSIONSFORMULTIPLECANCEL_QUERY = `
  query getSubscriptionsSessionsForMultipleCancel($request: SubscriptionsForCancelInput!) {
    getSubscriptionsSessionsForMultipleCancel(request: $request)
  }`;

export const getSubscriptionsSessionsForMultipleCancelApiCall = async ({request}, ) => apiCall({ query: GETSUBSCRIPTIONSSESSIONSFORMULTIPLECANCEL_QUERY, variables: {request}});

const VALIDATEMULTIPLESESSIONSMEMBERSHIPRULES_QUERY = `
  query validateMultipleSessionsMembershipRules($sessions: [Int]!, $classId: Int!, $userId: Int, $customerId: Int) {
    validateMultipleSessionsMembershipRules(sessions: $sessions, classId: $classId, userId: $userId, customerId: $customerId)
    {
      message
			failedPeriods
      ...fragments
    }
  }`;

export const validateMultipleSessionsMembershipRulesApiCall = async ({sessions, classId, userId, customerId}, fragments = null) => apiCall({ query: VALIDATEMULTIPLESESSIONSMEMBERSHIPRULES_QUERY, variables: {sessions, classId, userId, customerId}, fragments });

const GETSESSIONSFORSUBSCRIPTIONMOVE_QUERY = `
  query getSessionsForSubscriptionMove($subscriptionId: Int!, $sessionId: Int!) {
    getSessionsForSubscriptionMove(subscriptionId: $subscriptionId, sessionId: $sessionId)
  }`;

export const getSessionsForSubscriptionMoveApiCall = async ({subscriptionId, sessionId}, ) => apiCall({ query: GETSESSIONSFORSUBSCRIPTIONMOVE_QUERY, variables: {subscriptionId, sessionId}});

const CHECKSUBSCRIPTIONSSESSIONMOVE_QUERY = `
  query checkSubscriptionsSessionMove($fromSessionId: Int!, $toSessionId: Int!, $subscriptionIds: [Int]!) {
    checkSubscriptionsSessionMove(fromSessionId: $fromSessionId, toSessionId: $toSessionId, subscriptionIds: $subscriptionIds)
  }`;

export const checkSubscriptionsSessionMoveApiCall = async ({fromSessionId, toSessionId, subscriptionIds}, ) => apiCall({ query: CHECKSUBSCRIPTIONSSESSIONMOVE_QUERY, variables: {fromSessionId, toSessionId, subscriptionIds}});

const CREATESUBSCRIPTION_QUERY = `
  mutation createSubscription($request: SubscriptionCreateRequest) {
    createSubscription(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const createSubscriptionApiCall = async ({request}, fragments = null) => apiCall({ query: CREATESUBSCRIPTION_QUERY, variables: {request}, fragments });

const CREATESUBSCRIPTIONONPASTEVENT_QUERY = `
  mutation createSubscriptionOnPastEvent($request: SubscriptionCreateRequest) {
    createSubscriptionOnPastEvent(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const createSubscriptionOnPastEventApiCall = async ({request}, fragments = null) => apiCall({ query: CREATESUBSCRIPTIONONPASTEVENT_QUERY, variables: {request}, fragments });

const CREATESUBSCRIPTIONASANONYMOUS_QUERY = `
  mutation createSubscriptionAsAnonymous($classId: Int!, $sessions: [Int]!, $email: String!, $onlyBook: Boolean, $firstname: String, $lastname: String, $phone: String) {
    createSubscriptionAsAnonymous(classId: $classId, sessions: $sessions, email: $email, onlyBook: $onlyBook, firstname: $firstname, lastname: $lastname, phone: $phone)
    {
      id
			message
			success
			amount
			amountCents
			clientSecret
			stripeAccount
			offerId
			productId
      ...fragments
    }
  }`;

export const createSubscriptionAsAnonymousApiCall = async ({classId, sessions, email, onlyBook, firstname, lastname, phone}, fragments = null) => apiCall({ query: CREATESUBSCRIPTIONASANONYMOUS_QUERY, variables: {classId, sessions, email, onlyBook, firstname, lastname, phone}, fragments });

const CONFIRMSUBSCRIPTION_QUERY = `
  mutation confirmSubscription($code: JSON!) {
    confirmSubscription(code: $code)
  }`;

export const confirmSubscriptionApiCall = async ({code}, ) => apiCall({ query: CONFIRMSUBSCRIPTION_QUERY, variables: {code}});

const ACTIVATESUBSCRIPTION_QUERY = `
  mutation activateSubscription($id: Int!) {
    activateSubscription(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const activateSubscriptionApiCall = async ({id}, fragments = null) => apiCall({ query: ACTIVATESUBSCRIPTION_QUERY, variables: {id}, fragments });

const CANCELSUBSCRIPTION_QUERY = `
  mutation cancelSubscription($subscriptionId: Int!) {
    cancelSubscription(subscriptionId: $subscriptionId)
    {
      id
			success
			message
			reimbursedSessionsCount
			walletReimburseAmount
      ...fragments
    }
  }`;

export const cancelSubscriptionApiCall = async ({subscriptionId}, fragments = null) => apiCall({ query: CANCELSUBSCRIPTION_QUERY, variables: {subscriptionId}, fragments });

const CANCELSUBSCRIPTIONSESSION_QUERY = `
  mutation cancelSubscriptionSession($subscriptionId: Int!, $sessionId: Int!) {
    cancelSubscriptionSession(subscriptionId: $subscriptionId, sessionId: $sessionId)
    {
      id
			success
			message
			reimbursedSessionsCount
			walletReimburseAmount
      ...fragments
    }
  }`;

export const cancelSubscriptionSessionApiCall = async ({subscriptionId, sessionId}, fragments = null) => apiCall({ query: CANCELSUBSCRIPTIONSESSION_QUERY, variables: {subscriptionId, sessionId}, fragments });

const CREATESESSIONSFORSUBSCRIPTIONN_QUERY = `
  mutation createSessionsForSubscriptionN($request: CreateSessionsSubscriptionNInput!) {
    createSessionsForSubscriptionN(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const createSessionsForSubscriptionNApiCall = async ({request}, fragments = null) => apiCall({ query: CREATESESSIONSFORSUBSCRIPTIONN_QUERY, variables: {request}, fragments });

const CANCELSUBSCRIPTIONSOFUSERINSPECIFICCLASS_QUERY = `
  mutation cancelSubscriptionsOfUserInSpecificClass($classId: Int!, $userId: Int, $customerId: Int) {
    cancelSubscriptionsOfUserInSpecificClass(classId: $classId, userId: $userId, customerId: $customerId)
  }`;

export const cancelSubscriptionsOfUserInSpecificClassApiCall = async ({classId, userId, customerId}, ) => apiCall({ query: CANCELSUBSCRIPTIONSOFUSERINSPECIFICCLASS_QUERY, variables: {classId, userId, customerId}});

const CHANGEUSERSESSIONSUBSCRIPTIONPRESENCE_QUERY = `
  mutation changeUserSessionSubscriptionPresence($sessionId: Int!, $subscriptionId: JSON!, $presence: String!) {
    changeUserSessionSubscriptionPresence(sessionId: $sessionId, subscriptionId: $subscriptionId, presence: $presence)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const changeUserSessionSubscriptionPresenceApiCall = async ({sessionId, subscriptionId, presence}, fragments = null) => apiCall({ query: CHANGEUSERSESSIONSUBSCRIPTIONPRESENCE_QUERY, variables: {sessionId, subscriptionId, presence}, fragments });

const CANCELSESSIONWITHALLSUBSCRIPTIONS_QUERY = `
  mutation cancelSessionWithAllSubscriptions($id: Int!) {
    cancelSessionWithAllSubscriptions(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const cancelSessionWithAllSubscriptionsApiCall = async ({id}, fragments = null) => apiCall({ query: CANCELSESSIONWITHALLSUBSCRIPTIONS_QUERY, variables: {id}, fragments });

const CANCELMULTIPLESUBSCRIPTIONSSESSIONSBYIDS_QUERY = `
  mutation cancelMultipleSubscriptionsSessionsByIds($subscriptionSessionsIds: JSON!, $inactiveOnly: Boolean, $cancelSession: Boolean) {
    cancelMultipleSubscriptionsSessionsByIds(subscriptionSessionsIds: $subscriptionSessionsIds, inactiveOnly: $inactiveOnly, cancelSession: $cancelSession)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const cancelMultipleSubscriptionsSessionsByIdsApiCall = async ({subscriptionSessionsIds, inactiveOnly, cancelSession}, fragments = null) => apiCall({ query: CANCELMULTIPLESUBSCRIPTIONSSESSIONSBYIDS_QUERY, variables: {subscriptionSessionsIds, inactiveOnly, cancelSession}, fragments });

const MOVESUBSCRIPTIONSESSION_QUERY = `
  mutation moveSubscriptionSession($subscriptionId: Int!, $fromSessionId: Int!, $toSessionId: Int!, $overlapConfirmed: Boolean) {
    moveSubscriptionSession(subscriptionId: $subscriptionId, fromSessionId: $fromSessionId, toSessionId: $toSessionId, overlapConfirmed: $overlapConfirmed)
  }`;

export const moveSubscriptionSessionApiCall = async ({subscriptionId, fromSessionId, toSessionId, overlapConfirmed}, ) => apiCall({ query: MOVESUBSCRIPTIONSESSION_QUERY, variables: {subscriptionId, fromSessionId, toSessionId, overlapConfirmed}});

const MOVESUBSCRIPTIONSSESSION_QUERY = `
  mutation moveSubscriptionsSession($fromSessionId: Int!, $toSessionId: Int!, $subscriptionIds: [Int]!, $overlapConfirmedIds: [Int]) {
    moveSubscriptionsSession(fromSessionId: $fromSessionId, toSessionId: $toSessionId, subscriptionIds: $subscriptionIds, overlapConfirmedIds: $overlapConfirmedIds)
  }`;

export const moveSubscriptionsSessionApiCall = async ({fromSessionId, toSessionId, subscriptionIds, overlapConfirmedIds}, ) => apiCall({ query: MOVESUBSCRIPTIONSSESSION_QUERY, variables: {fromSessionId, toSessionId, subscriptionIds, overlapConfirmedIds}});
